<template>
  <main class="role-page page-padding page-sidebar">
    <role-users-list></role-users-list>
    <role-info @reload="reloadRole"></role-info>
    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </main>
</template>

<script>
  import {mapState,mapGetters,mapMutations,mapActions} from 'vuex'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {hideRoles} from "../../mixins/roles/hideRoles";
  import {loaderMixin} from "../../mixins/utils/loaderMixin";

  import roleInfo from '../../components/Pages/Role/roleInfo'
  import roleUsersList from '../../components/Pages/Role/roleUsersList'

  export default {
    name: 'rolePage',
    mixins: [tokenAndRoute, hideRoles, loaderMixin],
    components: {
      roleInfo,
      roleUsersList
    },
    computed: {
      ...mapGetters({
        activeRole: 'roles/activeRole'
      }),
    },
    watch: {
      rolesTree(val) {
        if (!this.activeRole) {
          this.$router.push('/404')
        } else {
          document.title = `OmniioTh | Роль ${this.activeRole.name}`
          this.setFullSidebar(false);
          this.setLinkName('roles');
          this.setRouteName(this.activeRole.name)
        }
      }
    },
    methods: {
      ...mapMutations({
        setFullSidebar: 'sidebar/SET_DASHBOARD',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME'
      }),
      ...mapActions({
        getUsers: 'roles/getUsers',
        getOwnedThings: 'things/getDevices',
        getOwnedRoles: 'roles/getOwnedRoles',
      }),
      reloadRole() {
        this.getOwnedRoles()
      }
    },
    beforeRouteEnter(to, from, next) {
      next (async vm => {
        const token = localStorage.getItem('token');
        if (token) {
          vm.showLoader();
          await vm.getOwnedThings({token, id: ''});
          await vm.getOwnedRoles({token, id: ''});

          vm.setFullSidebar(false);
          vm.setLinkName('roles');
          vm.setRouteName(vm.activeRole.name);

          vm.getUsers(token);
          vm.hideLoader()
        }
      })
    }
  }
</script>

<style lang="scss" scoped>

</style>
